//@ts-check
import { constants } from 'lib_ui-services';
import { BbState } from 'lib_ui-primitives';
export default {
    verb: 'didCreate',
    namespace: 'item',
    relation: 'transaction',
    description: 'increment pallet counter',
    priority: 10,
    useCaseIds: [constants.useCaseIds.FREIGHT_RUNNER, constants.useCaseIds.RB_DIRECTSCAN],

    //this is the actual logic:
    logic: didCreate
};

async function didCreate({ context, dispatch }) {
    const retention = {
        id: context.session.profile.userId,
        scope: constants.retention.SCOPE.LOCAL,
        visibility: constants.retention.VISIBILITY.PER_BROWSER,
        duration: constants.retention.DURATION.USER_SESSION
    };
    const bbState = BbState.connect(retention);
    let previousCounter = await bbState.getAsync('palletCounter', 0);
    await bbState.setAsync(previousCounter + 1, 'palletCounter');

    const firstScan = await bbState.getAsync('firstScan', null);
    if (!firstScan) {
        await bbState.setAsync(new Date(), 'firstScan');
    }

    if (context?.session?.useCase?.['metaui:useCase']?._id === constants.useCaseIds.RB_DIRECTSCAN) {
        dispatch(
            {
                message: 'Transaction saved',
                timeout: 3000,
                variant: 'success',
                type: constants.notificationTypes.TOAST
            },
            { verb: 'pop', namespace: 'application', relation: 'notification' }
        );
    }
}
